import { GridGetRowsParams } from '@mui/x-data-grid-premium'
import { QueryKey } from '@tanstack/react-query'

/**
 * Creates a structured query key for React Query cache management
 *
 * @param queryKeyBase - Base identifier for the query (e.g., 'documents-v2', 'users')
 * @param params - Grid parameters from MUI DataGrid
 * @param extraParams - Additional parameters specific to the query
 * @returns Structured query key array optimized for React Query operations
 */
export function createQueryKey(
  queryKeyBase: string,
  params: Pick<GridGetRowsParams, 'paginationModel' | 'filterModel' | 'sortModel'>,
  extraParams?: Record<string, unknown>
): QueryKey {
  return [
    queryKeyBase,
    {
      pagination: params.paginationModel,
      filter: params.filterModel,
      sort: params.sortModel,
      extra: extraParams,
    },
  ]
}
